export default "__VITE_ASSET__DahpWpFV__"